/* 6 Oct 2026: also loads assets/pullorax-fuzzy.js (typo-tolerant search, wholesale page additions) on every page.
   The extra "r" parameter changes every hour, so updates to pullorax-fuzzy.js / pullorax-b2b-plus.js reach visitors within an hour. */
(function () {
  var s = document.currentScript;
  if (!s || !s.src || document.getElementById('px-fuzzy-js')) return;
  var f = document.createElement('script');
  f.id = 'px-fuzzy-js';
  var u = s.src.replace(/pullorax-back\.js/, 'pullorax-fuzzy.js');
  f.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'r=' + Math.floor(Date.now() / 3600000);
  f.defer = true;
  document.head.appendChild(f);
})();

/*
  16 Oct 2026 (owner-approved): CONTINUE SHOPPING memory. Every page except the cart remembers its
  address and how far it was scrolled when the visitor leaves it (sessionStorage, this tab only). The
  cart's Continue shopping button links there and asks for that spot back; the page scrolls to it on
  arrival. This theme often scrolls inside .page-wrapper rather than the window, so both are covered.
*/
(function () {
  'use strict';
  var isCart = /\/cart(\/|$)/.test(location.pathname);
  function scroller() { return document.querySelector('.page-wrapper'); }
  function pos() { var pw = scroller(); return window.pageYOffset || (pw && pw.scrollTop) || 0; }
  if (!isCart) {
    var save = function () { try { sessionStorage.setItem('px-last', JSON.stringify({ u: location.href, y: Math.round(pos()) })); } catch (e) {} };
    window.addEventListener('pagehide', save);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') save(); });
    window.pxSaveSpot = save;
  }
  var want = null;
  try { want = JSON.parse(sessionStorage.getItem('px-restore') || 'null'); } catch (e) {}
  if (!want || want.u !== location.href) return;
  try { sessionStorage.removeItem('px-restore'); } catch (e) {}
  var tries = 0;
  (function go() {
    var pw = scroller();
    // 'instant': the page has scroll-behavior:smooth, and a smooth scroll is cut short by the page still loading.
    if (pw && pw.scrollHeight > pw.clientHeight + 1) pw.scrollTo({ top: want.y, behavior: 'instant' }); else window.scrollTo({ top: want.y, behavior: 'instant' });
    if (Math.abs(pos() - want.y) > 4 && ++tries < 20) setTimeout(go, 150);
  })();
})();

/*
  PulloraX - BACK button (floating, top-left, every page - 30 Sept 2026).
  Came from inside the site  -> browser back (same page, same scroll position).
  Came from Google / a link  -> the logical parent page (data-fallback, set in the layout).
  Home page (data-home="1"): shown only when the visitor came from inside the site.
*/
(function () {
  'use strict';
  var script = document.currentScript;
  if (!script) return;
  var fallback = script.dataset.fallback || '/';
  var isHome = script.dataset.home === '1';

  function internalReferrer() {
    try {
      return document.referrer && new URL(document.referrer).host === location.host && history.length > 1;
    } catch (e) { return false; }
  }
  if (isHome && !internalReferrer()) return;

  var lang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  var labels = { he: 'חזרה', fr: 'Retour', de: 'Zurück', ja: '戻る', es: 'Volver', it: 'Indietro' };
  var label = (window.PXT && window.PXT.back) || labels[lang] || 'Back';

  var a = document.createElement('a');
  a.href = fallback;
  a.className = 'px-back';
  a.setAttribute('aria-label', label);
  a.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg><span>' + label + '</span>';
  a.addEventListener('click', function (e) {
    e.preventDefault();
    if (internalReferrer()) history.back();
    else location.href = fallback;
  });
  document.body.appendChild(a);

  // Sit just under the header; rise to the top edge once the header has scrolled away.
  var sel = '#header-group, header-component, .pxmh';
  var ticking = false;
  function place() {
    ticking = false;
    var els = document.querySelectorAll(sel), bottom = 0;
    for (var i = 0; i < els.length; i++) {
      if (a.contains(els[i])) continue;
      var r = els[i].getBoundingClientRect();
      if (r.height > 0 && r.bottom > bottom) bottom = r.bottom;
    }
    a.style.top = Math.max(12, Math.round(bottom + 12)) + 'px';
    // QA 9 Oct 2026: once the header has scrolled away the button would float over the page text,
    // so on phones and tablets it hides while scrolling down and comes back on scroll up.
    var y = scrollPos();
    // 15 Oct 2026 (owner-approved): the same on desktop - there it sat over the cart page's
    // "You may also like" heading.
    if (bottom <= 0 && y > lastY + 2) a.classList.add('is-away');
    else if (y < lastY - 2 || bottom > 0) a.classList.remove('is-away');
    lastY = y;
  }
  var mq = window.matchMedia('(max-width: 900px)');
  // 15 Oct 2026: on this theme the page usually scrolls inside .page-wrapper, not the window, so a
  // window-only listener never fired - the button stayed under the header's first position and
  // floated over the content. Read whichever of the two is scrolling, and listen to both.
  var pw = document.querySelector('.page-wrapper');
  function scrollPos() { return window.pageYOffset || (pw && pw.scrollTop) || 0; }
  var lastY = scrollPos();

  // QA 9 Oct 2026: at rest (top of the page) the button must not sit on the breadcrumb, title or
  // magazine header. Measure the first content under it and push the main content down by just
  // the overlap (only on phones/tablets; nothing changes where there is already room).
  var main = document.getElementById('MainContent');
  function clear() {
    if (!main) return;
    main.style.removeProperty('padding-top');
    // QA 9 Oct 2026: desktop too - the 89px BACK pill covered 'Home' in the breadcrumb at 1440.
    var hdr = 0, els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) {
      var hr = els[i].getBoundingClientRect();
      if (hr.height > 0 && hr.bottom + window.pageYOffset > hdr) hdr = hr.bottom + window.pageYOffset;
    }
    var bw = a.offsetWidth || 44, bh = a.offsetHeight || 44;
    var btnL = 16, btnR = 16 + bw + 8, btnB = hdr + 12 + bh + 8, minTop = Infinity;
    var w = document.createTreeWalker(main, NodeFilter.SHOW_ELEMENT);
    var n, cnt = 0;
    while ((n = w.nextNode()) && cnt < 400) {
      cnt++;
      var tag = n.tagName;
      var leaf = tag === 'IMG' || tag === 'A' || tag === 'BUTTON' || /^H[1-6]$/.test(tag) ||
        [].some.call(n.childNodes, function (c) { return c.nodeType === 3 && c.textContent.trim(); });
      // QA 9 Oct 2026: a framed box (e.g. the magazine "PULLORAX SET FILE" plate) counts from its
      // border, not from the text inside it - otherwise the button still sat on the frame.
      if (!leaf && n.offsetWidth && n.offsetWidth < main.clientWidth - 8) {
        var bs = getComputedStyle(n);
        leaf = parseFloat(bs.borderTopWidth) > 0 && bs.borderTopStyle !== 'none';
      }
      if (!leaf) continue;
      var r = n.getBoundingClientRect();
      if (!r.width || !r.height) continue;
      var top = r.top + window.pageYOffset;
      if (top > btnB + 200) continue;
      if (r.right > btnL && r.left < btnR && top < btnB && r.bottom + window.pageYOffset > hdr) {
        var cs = getComputedStyle(n);
        if (cs.visibility === 'hidden' || cs.position === 'fixed') continue;
        if (n.closest('[aria-hidden="true"]') && cs.pointerEvents === 'none') continue; // decorative ghost text (e.g. the big 'M6a')
        if (top < minTop) minTop = top;
      }
    }
    if (minTop < btnB) {
      var pad = parseFloat(getComputedStyle(main).paddingTop) || 0;
      main.style.setProperty('padding-top', Math.ceil(pad + btnB - minTop) + 'px');
    }
  }
  function queue() { if (!ticking) { ticking = true; requestAnimationFrame(place); } }
  place();
  clear();
  var rt;
  window.addEventListener('scroll', queue, { passive: true });
  if (pw) pw.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', function () { queue(); clearTimeout(rt); rt = setTimeout(clear, 200); });
  window.addEventListener('load', function () { place(); clear(); });
})();